// extracted by mini-css-extract-plugin
module.exports = {"dashboardWrapper":"__dashboardWrapper___SpYXu","main":"__main___3CaTm"};